/**
 *
 *
 * This is the translation file for the ICAT project. All the English text that is used in the project is collected in this file.
 * This file is based on the Lang Excel file which is approved by Etherstack.
 * Current version of this file is Ver 1.11 which is in sync with excel file-ICAT_ Language File V1.12
 * No modification to this file shall be done without approvals
 *
 */

import {
  IPageTranslation,
  Page,
  Operation,
  IGeneralTranslation,
  GeneralTranslationCategory,
} from "./types";

export const pageTranslation: IPageTranslation = {
  [Page.ORG]: {
    [Operation.READ]: {
      header: "Organisations",
      headerSubtext: "Provisioning of LMR Organisations.",
      editRow: {
        header: "Organisation",
        panelName: "Organisation",
      },
    },
    [Operation.CREATE]: {
      header: "New Organisation",
      headerSubtext: "Provisioning of LMR Organisations.",
      cancelModal: {
        header: "Cancel Create Organisation",
        modalContent:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
      buttonLabels: {
        cancel: "Cancel",
        goBack: "Yes, Go Back",
        create: "Create Organisation",
      },
      sucessMsg: "Organisation Created Successfully!",
    },
    [Operation.EDIT]: {
      header: "Organisation",
      panelName: "Organisation",

      editableFields: {
        labels: {
          name: "Organisation Name",
        },
        name: {
          orgName: "ORG-NAME",
        },
        tooltipText: {
          name: "The display name of the LMR Organisation.",
        },
      },
    },
    [Operation.DELETE]: {
      successAlertMessage: "Organisation Deleted Successfully!",
    },
  },

  [Page.ORG_MAPPING]: {
    [Operation.READ]: {
      header: "Organisation Mappings",
      headerSubtext: "Provisioning of LMR Organisation Mapping.",
      deleteModal: {
        header: "Delete Mapping",
        description: (connectionId: string | null) =>
          `Are you sure you want to delete this Mapping` +
          ` (${connectionId}). ` +
          `You cannot undo this action.`,
      },
    },
    [Operation.CREATE]: {
      header: "New Organisation Mapping",
      headerSubtext: "Provisioning of LMR Organisation Mapping.",
      buttonLabels: {
        cancel: "Cancel",
        create: "Create Mapping",
      },
      sucessMessage: "Mapping Created Successfully!",
      errorMessage: "Mapping Creation Failed",
      draftAbortModal: {
        header: "Cancel Create Mapping",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        confirmButtonLabel: "Yes, Go Back",
      },
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "Mapping Deleted Successfully!",
    },
  },

  [Page.ORG_TRANSLATION]: {
    [Operation.READ]: {
      header: "Organisation Translations",
      headerSubtext: "Provisioning of LMR Organisation Translation.",
      translationDropdown: {
        titleText: "Select Translation",
        label: "Select a Translation...",
      },
      editRow: {
        header: "Translation",
        panelName: "Organisation Translation",
      },
      infoAlert: {
        heading: "Select Translation Type and Organisation from the dropdown",
        subText:
          "Please select an Organisation and Translation Type from the dropdown to view the Translations",
      },
    },
    [Operation.CREATE]: {
      header: "New Organisation Translation",

      headerSubtext: "Provisioning of LMR Organisation Translation.",
      translationDropdownText: "Select Translation",
      infoAlert: {
        heading: "Select Translation Type and Organisation from the dropdown",
        subText:
          "Please select an Organisation and Translation Type from the dropdown to view the Translations",
      },
      dropdown: {
        label: "Select a Translation...",
        dropdownItems: {
          "floor-control": "Floor Control",
          "P25-TO-MC-FC-PRI": "P25 to MCX",
          "MC-TO-P25-FC-PRI": "MCX to P25",
          "DMR-TO-MC-FC-PRI": "DMR to MCX",
          "MC-TO-DMR-FC-PRI": "MCX to DMR",
        },
      },
      successMsg: "Translation Created Successfully!",
      errorMsg: "Translation creation failed",
      btnLabels: {
        cancelConfirmationLabel: "Yes, Go Back",
        cancel: "Cancel",
        create: "Create Translation",
      },
      cancelModal: {
        header: "Cancel Create Translation",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "Translation Deleted Successfully!",
    },
  },

  [Page.LOCATION]: {
    [Operation.READ]: {
      header: "Locations",
      headerSubtext: "Provisioning of LMR IWF Deployment Locations.",
      editRow: {
        header: "Location",
        panelName: "Location",
      },
    },
    [Operation.CREATE]: {
      header: "New Location",
      headerSubtext: "Provisioning of LMR IWF Deployment Locations.",
      labels: {
        id: "IWF ID",
        name: "IWF Location Name",
        domain: "IWF Domain Name",
      },
      names: {
        id: "IWF ID",
        locationName: "IWF Location Name",
        domain: "IWF Domain Name",
      },
      buttonLabels: {
        cancel: "Cancel",
        create: "Create Location",
        goBack: "Yes, Go Back",
      },
      tooltipText: {
        id: "Defines the ID of the LMR IWF instance.",
        name: "Defines the location name of the LMR IWF instance.",
        domain: "Defines the domain name of the LMR IWF instance.",
      },
      createModal: {
        header: "Cancel Create Location",
        modalContent:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
      successMsg: "Location Created Successfully!",
    },
    [Operation.EDIT]: {
      header: "Location",
      panelName: "Location",
      readOnlyFields: {
        labels: {
          id: "IWF ID",
          name: "IWF Location Name",
        },
        name: {
          id: "IWF-ID",
          locationName: "IWF-LOCATION-NAME",
        },
        tooltipText: {
          idText: "Defines the ID of the LMR IWF instance",
          nameText: "Defines the location name of the LMR IWF instance",
        },
      },
      editableFields: {
        labels: {
          domain: "IWF Domain Name",
        },
        name: {
          domain: "IWF-DOMAIN-NAME",
        },
        tooltipText: {
          domain: "Defines the domain name of the LMR IWF instance.",
        },
      },
    },
    [Operation.DELETE]: {
      successAlertMessage: "Location Deleted Successfully!",
    },
  },

  [Page.XSSI_CONNECTION]: {
    [Operation.READ]: {
      header: "XSSI Connections",
      headerSubtext: "Provisioning of ISSI/CSSI Connections.",
      editRow: {
        description: (connectionId) =>
          `Are you sure you want to delete this Connection` +
          ` (${connectionId})? ` +
          `You cannot undo this action.`,
        panelName: "XSSI Connection",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Connections",
      },
    },
    [Operation.CREATE]: {
      successAlertMessage: "Connection Updated Successfully!",
      header: "New XSSI Connection",
      headerSubtext: "Provisioning of ISSI/CSSI connections.",
      reuseXSSIConnection: {
        reuseToggleLabel: "Re-Use Existing XSSI Connection",
        reuseToggleTooltip:
          "Enable to reuse connection. Disable to create a new one each time.",
        reuseableXSSIConnectionLabel: "Connection ID",
        reuseableXSSIConnectionTooltip: "The ID of the ISSI/CSSI Connection.",
        noMatchFound:
          "No Match Found. Please search correct XSSI Connection ID.",
      },
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on XSSI page to add connection for that department",
      },
      labels: {
        finishButton: "Finish",
        nextButton: "Next",
        proceedToRangesButon: "Proceed to Ranges",
        previousButton: "Previous",
        backToListing: "Back To Connection Listing",
      },
      tabList: [
        "Create Connection",
        "Add Unit Ranges",
        "Add IWF Unit Ranges",
        "Add IWF Group Ranges",
        "Add Radio Group Ranges",
      ],
      addConnection: {
        successAlertMessage: "Connection Created Successfully",
        deleteModal: {
          header: "Cancel Create XSSI Connection",
          description:
            "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
          goBackButtonLabel: "Yes, Go Back",
        },
        btnLabels: {
          cancel: "Cancel",
          createConnection: "Create Connection",
        },
      },
      ranges: {
        createNewUnitRangeText: "Create New Unit Range",
        createNewIWFUnitText: "Create New IWF Unit Range",
        createNewIWFRangeText: "Create New IWF Group Range",
        createNewRadioRangeText: "Create New Radio Group Range",
        addToRange: "Add Range",
        deleteModal: {
          title: "Delete Range",
          description:
            "Are you sure you want to delete this Range ? You cannot undo this action.",
          cancel: "Cancel",
          delete: "Yes, Delete It",
        },
      },
    },
    [Operation.EDIT]: {
      successAlertMessage: "Connection Updated Successfully!",
      connection: {
        heading: "Connection",
        labels: {
          updateConnection: "Update Connection",
        },
      },
      range: {
        successAlertMessage: "Range Added Successfully!",
        deleteSuccessAlertMessage: "Range deleted successfully!",
        editSuccessAlertMessage: "Range Updated Successfully!",
        labels: {
          creationDate: "Creation Date",
          modificationDate: "Modification Date",
          cancelButton: "Cancel",
          saveButton: "Save",
          editButton: "Edit",
          deleteButton: "Delete",
          discardButton: "Discard",
          id: "ID",
          groupLabelPrefix: "Group",
          unitLabelPrefix: "Unit",
          iwfUnitLabelPrefix: "IWF Unit",
          minId: (labelPrefix) => `${labelPrefix} Min ID`,
          maxId: (labelPrefix) => `${labelPrefix} Max ID`,
          maxInvalidText: (labelPrefix: string, min?: number, max?: number) =>
            `"${labelPrefix} Max ID" should be in the range [${min}, ${max}] and greater than ${labelPrefix} Min ID`,
          minInvalidText: (labelPrefix: string, min?: number, max?: number) =>
            `"${labelPrefix} Min ID" should be in the range [${min}, ${max}] and less than ${labelPrefix} Max ID`,
          maxToolTipText: (labelPrefix: string, min?: number, max?: number) =>
            `The end point (MAX) of the ${labelPrefix} Range (range ${min}-${max})`,
          minToolTipText: (labelPrefix: string, min?: number, max?: number) =>
            `The starting point (MIN) of the ${labelPrefix} Range (range ${min}-${max})`,
        },
        heading: {
          iwfGroup: "IWF Group",
          radioGroup: "Radio Group",
          unit: "Unit",
          iwfUnit: "IWF Unit",
        },
        ranges: "Ranges",
        unitRanges: "Unit Ranges",
        infoAlert: {
          heading: (groupName: string) =>
            `No ${groupName} Range Data found for this organisation!`,
          subText: "Please start adding data by clicking on 'Add range'",
        },
        unitRangeInfoAlert: {
          heading: "No Unit Range Data found for this organisation!",
          subText: "Please start adding data by clicking on 'Add range'",
        },
      },
      tabList: [
        "Connection",
        "Unit Ranges",
        "IWF Unit Ranges",
        "IWF Group Ranges",
        "Radio Group Ranges",
      ],
    },
    [Operation.DELETE]: {
      successAlertMessage: "Connection Deleted Successfully!",
    },
  },

  [Page.OTAR_CONNECTION]: {
    [Operation.READ]: {
      header: "OTAR Connections",
      headerSubtext: "Provisioning of OTAR connections.",
      editRow: {
        header: "OTAR Connection",
        panelName: "OTAR Connection",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Connections",
      },
    },
    [Operation.CREATE]: {
      header: "New OTAR Connection",
      headerSubtext: "Provisioning of OTAR connections.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on OTAR page to add connection for that department",
      },
      deleteModal: {
        header: "Cancel Create OTAR Connection",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create Connection",
      successAlertMessage: "Connection Created Successfully!",
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "Connection Deleted Successfully!",
    },
  },

  [Page.CANNED_MESSAGE]: {
    [Operation.READ]: {
      header: "Canned Messages",
      headerSubtext: "Provisioning of LMR Canned Messages.",
      editRow: {
        header: "Canned Message",
        panelName: "Canned Message",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view it's Messages",
      },
    },
    [Operation.CREATE]: {
      header: "New Canned Message",
      headerSubtext: "Provisioning of LMR Canned Messages.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on Canned message page to add message for that department",
      },
      deleteModal: {
        header: "Cancel Create Canned Message",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create Canned Message",
      successAlertMessage: "Canned Message Created Successfully!",
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "Canned Message Deleted Successfully!",
    },
  },

  [Page.LMR_USER]: {
    [Operation.READ]: {
      header: "LMR Users",
      headerSubtext: "Provisioning of LMR Users.",
      editRow: {
        header: "LMR User",
        panelName: "LMR User",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Users",
      },
    },
    [Operation.CREATE]: {
      header: "New LMR User",
      headerSubtext: "Provisioning of LMR Users.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on LMR User page to add a new user for that department",
      },
      deleteModal: {
        header: "Cancel Create LMR User",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create LMR User",
      successAlertMessage: "LMR User Created Successfully!",
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "LMR User Deleted Successfully!",
    },
  },

  [Page.LMR_GROUP]: {
    [Operation.READ]: {
      header: "LMR Groups",
      headerSubtext: "Provisioning of LMR Groups.",
      editRow: {
        header: "LMR Group",
        panelName: "LMR Group",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Groups",
      },
    },
    [Operation.CREATE]: {
      header: "New LMR Group",
      headerSubtext: "Provisioning of LMR Groups.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on LMR Group page to add a new user for that department",
      },
      deleteModal: {
        header: "Cancel Create LMR Group",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create LMR Group",
      successAlertMessage: "LMR Group Created Successfully!",
    },
    [Operation.EDIT]: {
      lmrGroup: {
        successAlertMessage: "Group Data Updated Successfully!",
      },
      lmrGroupProfile: {
        successAlertMessage: "Group Profile Data Updated Successfully!",
      },
    },
    [Operation.DELETE]: {
      successAlertMessage: "LMR Group Deleted Successfully!",
    },
  },

  [Page.MCPTT_USER]: {
    [Operation.READ]: {
      header: "MCPTT Users",
      headerSubtext: "Provisioning of MCPTT Users.",
      editRow: {
        header: "MCPTT User",
        panelName: "MCPTT User",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Users",
      },
    },
    [Operation.CREATE]: {
      header: "New MCPTT User",
      headerSubtext: "Provisioning of MCPTT Users.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on MCPTT Users page to add an user for that department",
      },
      deleteModal: {
        header: "Cancel Create MCPTT User",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create MCPTT User",
      successAlertMessage: "MCPTT User Created Successfully!",
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "MCPTT User Deleted Successfully!",
    },
  },

  [Page.MCPTT_GROUP]: {
    [Operation.READ]: {
      header: "MCPTT Groups",
      headerSubtext: "Provisioning of MCPTT Groups.",
      editRow: {
        header: "MCPTT Group",
        panelName: "MCPTT Group",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view it's groups",
      },
    },
    [Operation.CREATE]: {
      header: "New MCPTT Group",
      headerSubtext: "Provisioning of MCPTT Groups.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on MCPTT Groups page to add a new group for that department",
      },
      deleteModal: {
        header: "Cancel Create MCPTT Group",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create MCPTT Group",
      successAlertMessage: "MCPTT Group Created Successfully!",
    },
    [Operation.EDIT]: {
      mcGroup: {
        successAlertMessage: "Group Data Updated Successfully!",
      },
      mcGroupProfile: {
        successAlertMessage: "Group Profile Data Updated Successfully!",
      },
    },
    [Operation.DELETE]: {
      successAlertMessage: "MCPTT Group Deleted Successfully!",
    },
  },
  // DONE
  [Page.DFSI_CONNECTION]: {
    [Operation.READ]: {
      header: "DFSI Connections",
      headerSubtext: "Provisioning of DFSI Connections.",
      editRow: {
        header: "DFSI Connection",
        panelName: "DFSI Connection",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the DFSI Connections",
      },
      infoAlertHeading: {
        dataSearched: "No Data found for this organisation!",
        dataNotSearched: "No Connection Data found for this organisation!",
      },
      infoAlertSubText: {
        dataSearched:
          "No rows match the current filters, please Remove/Update some filters to view the results",
        dataNotSearched:
          'Please start creating connection data by clicking on “Create New"',
      },
    },
    [Operation.CREATE]: {
      header: "New DFSI Connection",
      headerSubtext: "Provisioning of DFSI Connections.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on DFSI Connection page to add connection for that department",
      },
      deleteModal: {
        header: "Cancel Create DFSI Connection",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create Connection",
      successAlertMessage: "Connection Created Successfully!",
    },
    [Operation.EDIT]: {
      deleteModal: {
        header: (header) => `Delete ${header}`,
        description: (header, data) =>
          `Are you sure you want to delete this ${header} (${data})?  The associated DFSI Channels will also be deleted. You cannot undo this action.`,
      },
      cancelModal: {
        header: (header) => `Cancel Edit ${header}`,
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
      btnLabel: {
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        save: "Save",
      },
      successAlertMessage: "Data Updated Successfully!",
    },
    [Operation.DELETE]: {
      successAlertMessage: "Connection Deleted Successfully!",
    },
  },
  // DONE
  [Page.DFSI_CHANNEL]: {
    [Operation.READ]: {
      header: "DFSI Channels",
      headerSubtext: "Provisioning of DFSI Channels.",
      editRow: {
        header: "DFSI Channel",
        panelName: "DFSI Channel",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the DFSI Channels",
      },
      infoAlertHeading: {
        dfsiConnectionExists: "No Connection Data found for this organisation!",
        channelsData: "No Channel Data found for this organisation!",
      },
      infoAlertSubText: {
        dfsiConnectionExists:
          "A DFSI Connection should exist to create a new DFSI channel. Please create DFSI connection",
        channelsData: 'Please create channel data by clicking on "Create New"',
      },
    },
    [Operation.CREATE]: {
      header: "New DFSI Channel",
      headerSubtext: "Provisioning of DFSI Channels.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on DFSI Channel page to add channels for that department",
      },
      deleteModal: {
        header: "Cancel Create DFSI Channel",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create Channel",
      successAlertMessage: "Channel Created Successfully!",
    },
    [Operation.EDIT]: {
      deleteModal: {
        header: (header) => `Delete ${header}`,
        description: (header, data) =>
          `Are you sure you want to delete this ${header}` +
          ` (${data})? ` +
          `You cannot undo this action.`,
      },
      cancelModal: {
        header: (header) => `Cancel Edit ${header}`,
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
      btnLabel: {
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        save: "Save",
      },
      successAlertMessage: "Data Updated Successfully!",
    },
    [Operation.DELETE]: {
      successAlertMessage: "DFSI Channel Deleted Successfully!",
    },
  },
  // DONE
  [Page.DFSI_GROUP]: {
    [Operation.READ]: {
      header: "DFSI Groups",
      headerSubtext: "Provisioning of DFSI Groups.",
      editRow: {
        header: "DFSI Group",
        panelName: "DFSI Group",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the DFSI Groups",
      },
      infoAlertHeading: {
        dfsiChannelIDExists: "No Channel Data found for this organisation!",
        groupData: "No group data found for this organisation !",
      },
      infoAlertSubText: {
        dfsiChannelIDExists:
          "A DFSI Channel should exist to create a new DFSI Group. Please create DFSI channel",
        groupData: 'Please create group data by clicking on "Create New"',
      },
    },
    [Operation.CREATE]: {
      header: "New DFSI Group",
      headerSubtext: "Provisioning of DFSI Groups.",
      infoAlert: {
        missingOrg: {
          heading: "Select a department to continue",
          subText:
            "Please select a department on DFSI group page to add groups for that department",
        },
        missingIWF: {
          heading: "No Organisation Mapping found",
          subText:
            "Please create a mapping for this organisation before creating a new DFSI Group",
        },
        missingIWFBulk: {
          heading: "No Organisation Mapping found",
          subText:
            "Please create a mapping for this organisation before  bulk uploading DFSI Group data",
        },
      },
      deleteModal: {
        header: "Cancel Create DFSI Group",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create Group",
      successAlertMessage: "Group Created Successfully!",
    },
    [Operation.EDIT]: {
      successMsg: "Data Updated Successfully!",
      btnLabel: {
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        save: "Save",
      },
      cancelModal: {
        header: (header) => `Cancel Edit ${header}`,
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      },
      deleteModal: {
        header: (header) => `Delete ${header}`,
        description: (header, data) =>
          `Are you sure you want to delete this ${header} (${data})? You cannot undo this action.`,
      },
    },
    [Operation.DELETE]: {
      successAlertMessage: "DFSI Group Deleted Successfully!",
    },
  },

  [Page.IKI_CONNECTION]: {
    [Operation.READ]: {
      header: "IKI Connections",
      headerSubtext: "Provisioning of IKI Connections.",
      editRow: {
        header: "IKI Connection",
        panelName: "IKI Connection",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view it's Messages",
      },
    },
    [Operation.CREATE]: {
      header: "New IKI Connection",
      headerSubtext: "Provisioning of IKI Connections.",
      infoAlert: {
        heading: "Select a department to continue",
        subText:
          "Please select a department on IKI Connection page to add message for that department",
      },
      deleteModal: {
        header: "Cancel Create IKI Connection",
        description:
          "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
        goBackButtonLabel: "Yes, Go Back",
      },
      cancelButtonLabel: "Cancel",
      createButtonLabel: "Create IKI Connection",
      successAlertMessage: "IKI Connection Created Successfully!",
    },
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "IKI Connection Deleted Successfully!",
    },
  },

  [Page.P25_UNIT]: {
    [Operation.READ]: {
      header: "P25 Supp. Service Reg. (Unit)",
      headerSubtext:
        "Preservation of P25 Supplementary Service Registrations(Unit) in the LMR IWF.",
      viewRow: {
        panelName: "P25 Supp. Service Reg. (Unit)",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Supplementry Services",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.FIXED_NETWORK_ELEMENT]: {
    [Operation.READ]: {
      header: "P25 Supp. Service Reg. (FNE)",
      headerSubtext:
        "Preservation of P25 Supplementary Service Registrations(FNE) in the LMR IWF.",
      viewRow: {
        panelName: "P25 Supp. Service Reg. (FNE)",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Supplementry Services",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "",
    },
  },

  [Page.P25_AFFILIATIONS]: {
    [Operation.READ]: {
      header: "P25 Group Affiliations",
      headerSubtext: "Preservation of P25 Group Affiliations in the LMR IWF.",
      viewRow: {
        panelName: "P25 Group Affiliations",
      },
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Supplementry Services",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {
      successAlertMessage: "",
    },
  },

  [Page.ACTIVE_ALARM]: {
    [Operation.READ]: {
      header: "Active Alarms",
      headerSubtext: "Fault Management Information.",
      viewRow: {
        panelName: "Active Alarm",
      },
      successAlertMessage: "Comment Added Successfully!",
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.FAULTS]: {
    [Operation.READ]: {
      header: "Faults",
      headerSubtext: "Fault Management Information.",
      viewRow: {
        panelName: "Fault",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.INVENTORY]: {
    [Operation.READ]: {
      header: "Inventory",
      headerSubtext: "Fault Management Information.",
      viewRow: {
        panelName: "Inventory",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.INSTANCE]: {
    [Operation.READ]: {
      header: "Instances",
      headerSubtext: "Fault Management Information.",
      viewRow: {
        panelName: "Instance",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.HISTORICAL_ALARM]: {
    [Operation.READ]: {
      header: "Historical Alarms",
      headerSubtext: "Fault Management Information.",
      editRow: {
        header: "",
        panelName: "Historical Alarm",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.PUBLISH_INFO]: {
    [Operation.READ]: {
      header: "Publish Info",
      headerSubtext: "Realtime Group/User Affiliations.",
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText: "Please select an Organisation from dropdown to view the Info",
      },
      editRow: {
        panelName: "Realtime Info",
        header: "Affiliation",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },

  [Page.P25_GROUP]: {
    [Operation.READ]: {
      header: "P25 Supp. Service Reg. (Group)",
      headerSubtext:
        "Preservation of P25 Supplementary Service Registrations(Group) in the LMR IWF.",
      infoAlert: {
        heading: "Select Organisation from the dropdown",
        subText:
          "Please select an Organisation from dropdown to view the Supplementry Services",
      },
      viewRow: {
        panelName: "P25 Supp. Service Reg. (Group)",
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },
  [Page.OVERVIEW]: {
    [Operation.READ]: {
      header: "Overview",
      headerSubtext: "ICAT artefacts summary",
      allOrgText: "All Organisations",
      config: {
        infoAlert: {
          heading: "Select Organisation from the dropdown",
          subText:
            "Please select an Organisation to view the Configuration Management summary data",
        },
      },
      realtime: {
        infoAlert: {
          heading: "Select Organisation from the dropdown",
          subText:
            "Please select an Organisation to view the Realtime summary data",
        },
      },
      chartModal: {
        getChartModalHeaderText: (
          selectedTab,
          ConfigTileList,
          RealTimeTileList,
          index
        ) => {
          let result = "";
          if (selectedTab === "Config") {
            result = `${ConfigTileList[index]} | Top Ten Organisations`;
          }
          if (selectedTab === "RealTime") {
            result = `${RealTimeTileList[index]} | Top Ten Organisations`;
          }
          return result;
        },
        getChartModalSubHeaderText: (
          selectedTab,
          ConfigTileList,
          RealTimeTileList,
          index
        ) => {
          let result = "";
          if (selectedTab === "Config") {
            result = `A visual view of the ${ConfigTileList[index]} count for the top ten organisations`;
          }
          if (selectedTab === "RealTime") {
            result = `A visual view of the ${RealTimeTileList[index]} count for the top ten organisations`;
          }
          return result;
        },
      },
      lineChart: {
        XaxisLabels: {
          min: "Min",
          max: "Max",
          avg: "Avg",
        },
      },
    },
    [Operation.CREATE]: {},
    [Operation.EDIT]: {},
    [Operation.DELETE]: {},
  },
};

export const generalTranslation: IGeneralTranslation = {
  [GeneralTranslationCategory.TABLE_HEADERS]: {
    [Page.ORG]: {
      "ORG-ID": "Organisation ID",
      "ORG-NAME": "Organisation Name",
      action: "ACTION",
    },
    [Page.ORG_MAPPING]: {
      "ORG-ID": "Organisation ID",
      "IWF-ID": "IWF ID",
      action: "Action",
    },
    [Page.ORG_TRANSLATION]: {
      ID: "ID",
      EFI: "Emergency Flag (Incoming)",
      EFO: "Emergency Flag (Outgoing)",
      FROM: "Priority (Incoming)",
      TO: "Priority (Outgoing) Value",
      action: "Action",
    },
    [Page.LOCATION]: {
      "IWF-ID": "IWF ID",
      "IWF-LOCATION-NAME": "IWF Location Name",
      "IWF-DOMAIN-NAME": "IWF Domain Name",
      action: "ACTION",
    },
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "RADIO-IPV4-ADDR": "Radio IPV4 Address",
      "RADIO-RFSS-ID": "Radio Frequency Subsystem ID",
      "RADIO-SYSTEM-ID": "Radio System ID",
      "RADIO-WACN-ID": "Radio Wide Area Communications Network ID",
      action: "Action",
    },
    [Page.OTAR_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "KMF-RADIO-SET-IDENTIFIER": "KMF Radio Set Identifier",
      "KMF-PORT": "KMF Port",
      "KMF-IPV4-ADDR": "KMF IPV4 Address",
      action: "Action",
    },
    [Page.CANNED_MESSAGE]: {
      "MSG-ID": "Message ID",
      "CANNED-TEXT": "Canned Text",
      action: "Action",
    },
    [Page.LMR_USER]: {
      "LMR-ID": "Land Mobile Radio ID",
      "LMR-NW-TYPE": "LMR Network Type",
      "MAPPED-MCPTT-ID": "MAPPED-MCPTT-ID",
      action: "Action",
    },
    [Page.LMR_GROUP]: {
      "TG-ID": "Talk Group ID",
      "MAPPED-MCPTT-GID": "MAPPED-MCPTT-GID",
      "LMR-NW-TYPE": "LMR Network Type",
      action: "Action",
    },
    [Page.MCPTT_USER]: {
      "MCPTT-ID": "MCPTT ID",
      "DISPLAY-NAME": "Display Name",
      action: "Action",
    },
    [Page.MCPTT_GROUP]: {
      "MCPTT-GID": "MCPTT GID",
      "MAPPED-P25-TG-ID": "MAPPED-P25-TG-ID",
      action: "Action",
    },
    [Page.DFSI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "DFSI-VERSION": "DFSI Version",
      "HOST-CONTROL-IPV4-ADDR": "Host Control IPV4 Address",
      "HOST-VOICE-IPV4-ADDR": "Host Voice IPV4 Address",
      "FIXED-STATION-CONTROL-IPV4-ADDR": "Fixed Station Control IPV4 Address",
      action: "Action",
    },
    [Page.DFSI_CHANNEL]: {
      "CONNECTION-ID": "Connection ID",
      "CHANNEL-ID": "Channel ID",
      "CHANNEL-MODE": "Channel Mode",
      "OUTBOUND-NETWORK-ACCESS-CODE": "Outbound Network Access Code",
      "INBOUND-NETWORK-ACCESS-CODE": "Inbound Network Access Code",
      action: "Action",
    },
    [Page.DFSI_GROUP]: {
      "DFSI-LOGICAL-GID": "DFSI Logical Group ID",
      "DFSI-GROUP-NAME": "DFSI Group Name",
      action: "Action",
    },
    [Page.IKI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "IKI-NAME": "IKI Name",
      "IKI-PORT": "IKI Port",
      "IKI-IPV4-ADDR": "IKI IPV4 Address",
      action: "Action",
    },
    [Page.FIXED_NETWORK_ELEMENT]: {
      "TARGET-ID": "Target ID",
      PERIOD: "Period",
      RFSS: "RFSS",
      MONITOR: "Monitor",
      action: "Action",
    },
    [Page.ACTIVE_ALARM]: {
      "NOTIFICATION-ID": "Notification ID",
      "EVENT-ID": "Event ID",
      HOSTNAME: "Hostname",
      CreatedAt: "Created At",
      action: "Action",
    },
    [Page.FAULTS]: {
      "EVENT-ID": "Event ID",
      HOSTNAME: "Hostname",
      CreatedAt: "Created At",
      INSTANCE: "Instance",
      VERSION: "Version",
      action: "Action",
    },
    [Page.INVENTORY]: {
      "EVENT-ID": "Event ID",
      "EVENT-NAME": "Event Name",
      "EVENT-PERCEIVED-SEVERITY": "Event Perceived Severity",
      "EVENT-SYMPTOMS": "Event Symptoms",
      "SOURCE-COMPONENT": "Source Component",
      state: "State",
      action: "Action",
    },
    [Page.INSTANCE]: {
      "ENGINE-ID": "Engine ID",
      HOSTNAME: "Hostname",
      INSTANCE: "Instance",
      "STARTED-AT": "Started At",
      action: "Action",
    },
    [Page.HISTORICAL_ALARM]: {
      "EVENT-ID": "Event ID",
      HOSTNAME: "Hostname",
      "ROW-TYPE": "Row Type",
      CreatedAt: "Created At",
      action: "Action",
    },
    [Page.P25_UNIT]: {
      "TARGET-ID": "Target ID",
      PERIOD: "Period",
      MONITOR: "Monitor",
      RFSS: "RFSS",
      action: "Action",
    },
    [Page.PUBLISH_INFO]: {
      "GROUP-ID": "Group ID",
      "USER-ID": "User ID",
      "SECS-TO-EXPIRE": "Seconds to Expire",
    },
    [Page.P25_GROUP]: {
      "TARGET-ID": "Target ID",
      PERIOD: "Period",
      RFSS: "RFSS",
      MONITOR: "Monitor",
      action: "Action",
    },
    [Page.P25_AFFILIATIONS]: {
      "TARGET-ID": "Target ID",
      PERIOD: "Period",
      RFSS: "RFSS",
      MONITOR: "Monitor",
      action: "Action",
    },
  },
  [GeneralTranslationCategory.TABLE_SEARCH]: {
    label: "Select Column",
    placeholder: "Search",
    closeButtonLabelText: "Clear search input",
  },
  [GeneralTranslationCategory.PERMISSION_DENIED_HEADER]: "Permission Denied!",
  [GeneralTranslationCategory.PERMISSION_DENIED_SUBTEXT]: (
    operation,
    module
  ) => {
    return `You don't have relevant permission to ${operation} ${module}`;
  },
  [GeneralTranslationCategory.FORM_VALIDATION]: {
    required: (text: string) => `"${text}" is a required property`,
    range: "is a required property and should be in the range",
    lessThan: "is a required property and should be less than",
    characterValidation: (text: string) =>
      `"${text}" should be 4 characters long`,
    IPV4Validation: (text: string) =>
      `"${text}" is a required property and should be a valid IPV4`,
    VocoderValidation: (text: string) =>
      `"${text}" is a required field and should be one of ("FR", "HR", "Native", "Phase 1")`,
    newtworkAccessCodeValidation: (
      text: string,
      range: string,
      invalidValue1: string,
      invalidValue2: string
    ) =>
      `"${text}" is a required property and should be in the range ${range} except ${invalidValue1} & ${invalidValue2}`,
    reservedIdentifier: ({ fieldName, reservedWord }) =>
      `"${fieldName}" is a required property and should not include reserved word "${reservedWord}"`,
  },
  [GeneralTranslationCategory.ADVANCED_SEARCH]: {
    label: "Advanced Search",
    cancelButtonLabel: "Cancel",
    applyButtonLabel: "Apply",
  },
  [GeneralTranslationCategory.LOADING_TEXT]: {
    defaultLoadingText: "Hang On, Fetching Data...",
    groupLoadingText: "Hang On, Fetching Group Data",
    groupProfileLoadingText: "Hang On, Fetching Group Profile Data",
    orgProfileLoadingText: "Hang On, Fetching Organisation Profile Data",
    orgLoadingText: "Hang On, Fetching Organisation Data",
  },
  [GeneralTranslationCategory.CREATE_NEW_BTN_LABEL]: "Create New",
  [GeneralTranslationCategory.SIDEPANEL_GENERAL]: {
    buttonLabels: {
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
    },
    nonEditableFields: {
      CreationDate: "Creation Date",
      ModificationDate: "Modification Date",
      "CONNECTION-ID": "Connection ID",
      "MCPTT-ID": "MCPTT ID",
      "DFSI-VERSION": "DFSI Version",
      "LMR-ID": "Land Mobile Radio ID",
      "MSG-ID": "Message ID",
      "TG-ID": "Talk Group ID",
      "MCPTT-GID": "MCPTT GID",
      "ORG-ID": "Organisation ID",
      "Reference ID": "Reference ID ",
      "Translation Type": "Translation Type",
      "Channel ID": "Channel ID",
      "DFSI-GROUP-NAME": "DFSI Group Name",
      "DFSI-LOGICAL-GID": "DFSI Logical Group ID",
      "IWF-ID": "IWF ID",
      "DFSI-UNIT-CONTROL-ATTEMPT-LIMIT": "DFSI Unit Control Attempt Limit",
      "DFSI-UNIT-CONTROL-RETRY-TIME": "DFSI Unit Control Retry Time",
      "IWF-ROLE": "IWF Role",
    },
    alarmsTabs: {
      comments: "Comments",
      additionalInfo: "Additional Info",
      commentField: {
        buttonLabel: "Comment",
        placeholder: "Add Comment",
      },
    },
    deleteModal: {
      header: "Delete Connection",
    },
  },
  [GeneralTranslationCategory.EDIT_ROW]: {
    CANCEL_MODAL: {
      header: "Cancel Edit",
      description:
        "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
      confirmationButtonLabel: "Yes, Go Back",
    },
    DELETE_MODAL: {
      header: "Delete",
      description: (header: string, data: string) =>
        `Are you sure you want to delete this ${header}  ${
          data ? `(${data})` : ""
        }? You cannot undo this action.`,
      buttonLabels: {
        keepIt: "No, Keep It",
        delete: "Yes, Delete It",
      },
    },
    EDIT_SUCCESS_MESSAGE: "Data Updated Successfully!",
  },
  [GeneralTranslationCategory.EDIT_GROUP]: {
    panelName: "Group Profile",
    cancelModal: {
      header: (header) => `Cancel Edit ${header}`,
      description:
        "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
    },
    cancelProfileModal: {
      header: (header) => `Cancel Edit ${header} Profile`,
      description:
        "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
    },
    deleteModal: {
      header: (header) => `Delete ${header}`,
      description: (header: string, data: string) =>
        `Are you sure you want to delete this ${header}  ${
          data ? `(${data})` : ""
        }? You cannot undo this action.`,
    },
  },
  [GeneralTranslationCategory.EDIT_ORG_PROFILE]: {
    profilePanelName: "Organisation Profile",
    cancelOrgModal: {
      header: (header) => `Cancel Edit ${header}`,
      description:
        "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
    },
    cancelOrgProfileModal: {
      header: (header) => `Cancel Edit ${header} Profile`,
      description:
        "Are you sure you want to go back and cancel this draft? Data you entered will not be saved.",
    },
    deleteOrgModal: {
      header: (header) => `Delete ${header}`,
      description: (header: string, data: string) =>
        `Are you sure you want to delete this ${header}  ${
          data ? `(${data})` : ""
        }? You cannot undo this action.`,
    },
    orgProfileSucessMsg: "Organisation Profile Data Updated Successfully!",
  },
  [GeneralTranslationCategory.ADD_FORM_FIELDS]: {
    [Page.ORG]: {
      "Organisation ID": {
        label: "Organisation ID",
        tooltipText: "The ID of the LMR Organisation.",
      },
      "Organisation Name": {
        label: "Organisation Name",
        tooltipText: "The display name of the LMR Organisation.",
      },
    },
    [Page.ORG_MAPPING]: {
      "IWF-ID": { label: "IWF ID", tooltipText: "The ID of the IWF." },
      "ORG-ID": {
        label: "Organisation ID",
        tooltipText: "The ID of the LMR Organisation.",
      },
    },
    [Page.ORG_TRANSLATION]: {},
    [Page.LOCATION]: {},
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": {
        label: "Connection ID",
        tooltipText: "The ID of the ISSI/CSSI Connection.",
      },
      "RADIO-IPV4-ADDR": {
        label: "Radio IPV4 Address",
        tooltipText: "The IPv4 Address of the agency RNC gateway.",
      },
      "RADIO-RFSS-ID": {
        label: "Radio Frequency Subsystem ID",
        tooltipText: "The RFSS ID of the agency RNC gateway (range 1-65535)",
      },
      "RADIO-SYSTEM-ID": {
        label: "Radio System ID",
        tooltipText: "The System ID of the agency RNC gateway (range 1-4095)",
      },
      "RADIO-WACN-ID": {
        label: "Radio Wide Area Communications Network ID",
        tooltipText: "The WACN ID of the agency RNC gateway (range 1-1048575)",
      },
      "RADIO-RFSS-4-HEX-DIGIT": {
        label: "Radio RFSS 4 Hex Digit",
        tooltipText:
          "The agency supports a 4 hex digit format for the RFSS ID (default true)",
      },
      "IWF-RFSS-ID": {
        label: "IWF Radio Frequency SubSystem ID",
        tooltipText: "The RFSS ID of the LMR IWF gateway (range 1-65535)",
      },
      "IWF-SYSTEM-ID": {
        label: "IWF System ID",
        tooltipText: "The System ID of the LMR IWF gateway (range 1-4095)",
      },
      "IWF-WACN-ID": {
        label: "IWF Wide Area Communications Network ID",
        tooltipText: "The WACN ID of the LMR IWF gateway (range 1-1048575)",
      },
      "POLLING-ENABLED": {
        label: "Polling Enabled",
        tooltipText: "Enable polling of the agency RNC gateway (default true)",
      },
      "POLLING-INTERVAL-CONNECTED": {
        label: "Polling Interval Connected",
        tooltipText:
          "The polling time in seconds when connected to the agency RNC gateway (default 10, range 1-300)",
      },
      "POLLING-INTERVAL-DISCONNECTED": {
        label: "Polling Interval Disconnected",
        tooltipText:
          "The polling time in seconds when disconnected from the agency RNC gateway (default 10, range 1-300)",
      },
      "RESPONSES-BEFORE-CONNECTED": {
        label: "Responses Before Connected",
        tooltipText:
          "The number of responses before connected (default 1, range 1-100)",
      },
      "MISSED-RESPONSES-BEFORE-DISCONNECTED": {
        label: "Missed Responses Before Disconnected",
        tooltipText:
          "The number of missed responses before disconnected (default 3, range 1-100)",
      },
      "VOCODER-MODES": {
        label: "Vocoder Modes",
        tooltipText:
          "The vocoder modes supported by the agency (FR, HR, Native, Phase 1)",
      },
      "REUSE-EXISTING-CONNECTION": {
        label: "Re-Use Existing Connection",
        tooltipText: "",
      },
      "SELECTED-ORGANISATION": {
        label: "Select Organisation",
        tooltipText: "",
      },
      "REUSED-CONNECTION": {
        label: "Connection ID",
        tooltipText: "The ID of the ISSI/CSSI Connection.",
      },
    },

    [Page.OTAR_CONNECTION]: {
      "CONNECTION-ID": {
        label: "Connection ID",
        tooltipText: "The ID of the OTAR Connection.",
      },
      "KMF-IPV4-ADDR": {
        label: "KMF IPV4 Address",
        tooltipText: "The IPv4 address of the agency KMF",
      },
      "KMF-PORT": {
        label: "KMF Port",
        tooltipText: "The UDP port of the agency KMF (range 1024-65535)",
      },
      "KMF-RADIO-SET-IDENTIFIER": {
        label: "KMF Radio Set Identifier",
        tooltipText: "The radio set identifier of the KMF (range 1-9999999)",
      },
      "IWF-RADIO-SET-IDENTIFIER": {
        label: "IWF Radio Set Identifier",
        tooltipText: "The radio set identifier (range 1-9999999)",
      },
      "MESSAGE-NUMBER-PERIOD": {
        label: "Message Number Period",
        tooltipText:
          "The message number period for OTAR message validation(range 0-65535)",
      },
      "PRIVATE-CALL-SLN": {
        label: "Private Call Storage Location Number",
        tooltipText: "The SLN for private calls (range 0-4095)",
      },
      "GROUP-REGROUP-SLN": {
        label: "Group Regroup Storage Location Number",
        tooltipText: "The SLN for group regroup calls (range 0-4095)",
      },
      "OTAR-REGISTRATION-TIMER": {
        label: "OTAR Registration Timer",
        tooltipText:
          "Time in hours to send OTAR registration (default 8, range 1-72)",
      },
      "KEEP-ALIVE-TIMER": {
        label: "Keep Alive Timer",
        tooltipText:
          "Time in seconds to send OTNR connection keep alive message Hello(identification) (default 0, range 0-300)",
      },
      "OPT-SEND-REKEY-REQ": {
        label: "OPT Send Rekey Request",
        tooltipText: "Send a re-key request (default false)",
      },
      "OPT-DE-REGISTRATION": {
        label: "OPT De-registration",
        tooltipText: "Support De-Registration (default false)",
      },
      "OPT-REVERSE-WARM-START": {
        label: "OPT Reverse Warm Start",
        tooltipText:
          "Support Registration using Reverse Warm Start (default false)",
      },
      "OPT-HELLO-MAC-REPLY": {
        label: "OPT Hello MAC Reply",
        tooltipText: "Only reply to Hello that has a MAC (default false)",
      },
      "OPT-KEY-ASSIGNMENT": {
        label: "OPT Key Assignment",
        tooltipText: "Support OTAR key assignment (default false)",
      },
    },
    [Page.CANNED_MESSAGE]: {
      "MSG-ID": {
        label: "Message ID",
        tooltipText: "The ID of the LMR Canned Message",
      },
      "CANNED-TEXT": {
        label: "Canned Text",
        tooltipText: "The LMR Canned Message Text.",
      },
    },
    [Page.LMR_USER]: {
      "LMR-ID": {
        label: "Land Mobile Radio ID",
        tooltipText: "The ID of the LMR User.",
      },
      "LMR-NW-TYPE": {
        label: "LMR Network Type",
        tooltipText: "The type of network associated with the LMR User.",
      },
      "MAPPED-MCPTT-ID": {
        label: "MAPPED-MCPTT-ID",
        tooltipText: "The mapped MCPTT ID of the LMR User.",
      },
      "DISPLAY-NAME": {
        label: "Display Name",
        tooltipText: "The display name of the LMR User",
      },
      "MUTUAL-AID": {
        label: "Mutual Aid",
        tooltipText: "The mutual aid value of the LMR User",
      },
    },
    [Page.LMR_GROUP]: {
      "TG-ID": {
        label: "Talk Group ID",
        tooltipText: "The ID of the LMR Talk Group.",
      },
      "LMR-NW-TYPE": {
        label: "LMR Network Type",
        tooltipText: "The type of network associated with the LMR Talk Group.",
        items: ["P25-ISSI", "P25-DFSI"],
      },
      "MAPPED-MCPTT-GID": {
        label: "MAPPED-MCPTT-GID",
        tooltipText: "The mapped MCPTT Group ID of the LMR Talk Group.",
      },
    },
    [Page.MCPTT_USER]: {
      "MCPTT-ID": { label: "MCPTT ID", tooltipText: "The ID of the MC User." },
      "DISPLAY-NAME": {
        label: "Display Name",
        tooltipText: "The display name of the MC User.",
      },
      "MAPPED-P25-ID": {
        label: "MAPPED-P25-ID",
        tooltipText: "The mapped P25 ID of the MC User.",
      },
      "MAPPED-DMR-ID": {
        label: "MAPPED-DMR-ID",
        tooltipText: "The mapped DMR ID of the MC User.",
      },
      "MAPPED-ROIP-ID": {
        label: "MAPPED-ROIP-ID",
        tooltipText: "The mapped ROIP ID of the MC User.",
      },
      "MAPPED-DFSI-ID": {
        label: "MAPPED-DFSI-ID",
        tooltipText: "The mapped DFSI ID of the MC User.",
      },
      "SELECT A MAPPED-FIELD": {
        label: "Select a Mapped Field",
        tooltipText: "The mapped fields of the MC User.",
        items: [
          "MAPPED-P25-ID",
          "MAPPED-DFSI-ID",
          "MAPPED-ROIP-ID",
          "MAPPED-DMR-ID",
          "MAPPED-P25-ID + MAPPED-DFSI-ID",
        ],
      },
      "MUTUAL-AID": {
        label: "Mutual Aid",
        tooltipText: "The mutual aid value of the MC User",
      },
    },
    [Page.MCPTT_GROUP]: {
      "MCPTT-GID": {
        label: "MCPTT GID",
        tooltipText: "The ID of the MC Group.",
      },
      "SELECT A MAPPED-FIELD": {
        label: "Select a Mapped Field",
        tooltipText: "The mapped values of the MC User.",
        items: [
          "MAPPED-P25-TG-ID",
          "MAPPED-DFSI-TG-ID",
          "MAPPED-ROIP-TG-ID",
          "MAPPED-DMR-TG-ID",
        ],
        placeholder: [
          "The mapped P25 Talk Group ID of the MC Group.",
          "The mapped DFSI Talk Group ID of the MC Group.",
          "The mapped ROIP Talk Group ID of the MC Group.",
          "The mapped DMR Talk Group ID of the MC Group.",
        ],
      },
    },
    [Page.DFSI_CONNECTION]: {
      "CONNECTION-ID": {
        label: "Connection ID",
        tooltipText: "The ID of the DFSI Connection",
      },
      "DFSI-VERSION": {
        label: "DFSI Version",
        tooltipText: "DFSI protocol version, either v1 or v2 (range 1-2)",
        items: ["1", "2"],
      },
      "IWF-ROLE": {
        label: "IWF Role",
        tooltipText: "The IWF DFSI role",
        items: ["Host", "Station"],
      },
      "HOST-CONTROL-IPV4-ADDR": {
        label: "Host Control IPV4 Address",
        tooltipText: "The IPv4 address of the host's control connection",
      },
      "HOST-CONTROL-PORT": {
        label: "Host Control Port",
        tooltipText:
          "The UDP port of the host's control connection (range 1024-65535)",
      },
      "HOST-VOICE-IPV4-ADDR": {
        label: "Host Voice IPV4 Address",
        tooltipText:
          "The IPv4 address of the host's voice conveyance connection",
      },
      "VOICE-PORT": {
        label: "Voice Port",
        tooltipText:
          "The UDP port of the host or fixed station's voice connection (range 1024-65535)",
      },
      "DATA-IPV4-ADDR": {
        label: "Data IPV4 Address",
        tooltipText:
          "DFSI v2 only, the IPv4 address of the host or fixed stations's data conveyance connection",
      },
      "DATA-PORT": {
        label: "Data Port",
        tooltipText:
          " DFSI v2 only, the UDP port of the host or fixed station's data connection (range 1024-65535)",
      },
      "FIXED-STATION-CONTROL-IPV4-ADDR": {
        label: "Fixed Station Control IPV4 Address",
        tooltipText:
          "The IPv4 address of the fixed station's control connection",
      },
      "FIXED-STATION-VOICE-IPV4-ADDR": {
        label: "Fixed Station Voice IPV4 Address",
        tooltipText:
          "The IPv4 address of the fixed station's voice conveyance connection (DFSI v1 only)",
      },
      "FIXED-STATION-CONTROL-PORT": {
        label: "Fixed Station Control Port",
        tooltipText:
          "The UDP port of the fixed station's control connection (range 1024-65535)",
      },
      "CONNECTIVITY-TX-TIMER": {
        label: "Connectivity Tx Timer",
        tooltipText:
          "The fixed station and host heartbeat send period in seconds (range 1-255)",
      },
      "CONNECTIVITY-LOSS-LIMIT": {
        label: "Connectivity Loss Limit",
        tooltipText:
          "The number of missed heartbeats before disconnected (range 1-100)",
      },
      "FS-HEARTBEAT-PERIOD": {
        label: "Fixed Station Heartbeat Period",
        tooltipText:
          "DFSI v1 only, the fixed station heartbeat period (range 1-255)",
      },
      "HOST-HEARTBEAT-PERIOD": {
        label: "Host Heartbeat Period",
        tooltipText: "DFSI v1 only, the host heartbeat period (range 1-255)",
      },
      "CONTROL-RETRY-TIME": {
        label: "Control Retry Time",
        tooltipText:
          "The control connection retry period in milliseconds (range 1-5000)",
      },
      "CONTROL-ATTEMPT-LIMIT": {
        label: "Control Attempt Limit",
        tooltipText: "The control connection retry attempt limit (range 1-10)",
      },
      "OUTBOUND-MAX-CAI-DATA-BLOCKS": {
        label: "Outbound Max Common Air Interface Data Blocks",
        tooltipText:
          "DFSI v2 only, the maximum number of outbound data blocks on the common air interface (range 1-128)",
      },
      "INBOUND-MAX-CAI-DATA-BLOCKS": {
        label: "Inbound Max Common Air Interface Data Blocks",
        tooltipText:
          "DFSI v2 only,the maximum number of inbound data blocks on the common air interface (range 1-128)",
      },
      "ACKNOWLEDGEMENT-DELAY": {
        label: "Acknowledgement Delay",
        tooltipText:
          "The number of seconds to delay acknowledgement (range 0-2)",
      },
      "INBOUND-REPEAT": {
        label: "Inbound Repeat",
        tooltipText: "Repeat inbound DFSI traffic",
      },
      "FIXED-STATION-VOTER-REPORTING-PERIOD": {
        label: "Fixed Station Voter Reporting Period",
        tooltipText: "The fixed station voter reporting period (range 1-255)",
      },
      "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL": {
        label: "Fixed Station Transmitter Report Interval",
        tooltipText:
          "DFSI v2 only, the fixed station transmitter report interval (range 1-255)",
      },
    },
    [Page.DFSI_CHANNEL]: {
      "CONNECTION-ID": {
        label: "Connection ID",
        tooltipText:
          "The LMR Organisation's CONNECTION ID associated with the DFSI Channel",
        items: [
          "Connection-v2-41",
          "Connection-v2-42",
          "Connection-v2-43",
          "Connection-v2-50",
          "Connection-v2-60",
          "Connection-v2-66",
          "Connection-v2-70",
          "Connection-v2-77",
        ],
      },
      "DFSI-VERSION": {
        label: "DFSI Version",
        tooltipText: "DFSI protocol version, either v1 or v2 (range 1-2)",
      },
      "CHANNEL-ID": {
        label: "Channel ID",
        tooltipText: "The ID of the DFSI Channel",
      },
      "OUTBOUND-NETWORK-ACCESS-CODE": {
        label: "Outbound Network Access Code",
        tooltipText:
          "A 12-bit network access code associated with a group's outbound voice transmissions (range 0-4095). Typically 0x293 (659) is configured by default, 0xF7E (3966) and 0xF7F (3967) are not allowed",
      },
      "INBOUND-NETWORK-ACCESS-CODE": {
        label: "Inbound Network Access Code",
        tooltipText:
          "A 12-bit network access code associated with a group's inbound voice transmissions (range 0-4095). Typically 0x293 (659) is configured by default, 0xF7E (3966) and 0xF7F (3967) are not allowed.",
      },
      "OTA-GROUP-ID": {
        label: "OTA Group ID",
        tooltipText:
          "A 16-bit over-the-air Talk Group ID associated with the conventional group (range 1-65535).",
      },
      "CARRIER-SQUELCH": {
        label: "Carrier Squelch",
        tooltipText: "",
      },
      "CHANNEL-MODE": {
        label: "Channel Mode",
        tooltipText:
          "The DFSI channel operating in either analog or digital mode.",
        items: ["Analog", "Digital"],
      },
      "CTC-SQUELCH-SYSTEM": {
        label: "CTC Squelch System",
        tooltipText:
          "Continuous Tone Coded Squelch System, Table 15 TIA.102 BAHA-A. Analog audio tone added to PTT, these are discrete values.",
        items: [
          "None",
          "0",
          "670",
          "693",
          "719",
          "744",
          "770",
          "797",
          "825",
          "854",
          "885",
          "915",
          "948",
          "974",
          "1000",
          "1035",
          "1072",
          "1109",
          "1148",
          "1188",
          "1230",
          "1273",
          "1318",
          "1365",
          "1413",
          "1462",
          "1514",
          "1567",
          "1622",
          "1679",
          "1738",
          "1799",
          "1862",
          "1928",
          "2035",
          "2065",
          "2107",
          "2181",
          "2257",
          "2291",
          "2336",
          "2418",
          "2503",
          "2541",
        ],
      },
      "CDC-SQUELCH-SYSTEM": {
        label: "CDC Squelch System",
        tooltipText:
          "Continuous Digital Coded Squelch System, Table 15 TIA.102 BAHA-A. Digital tone added to PTT, these are discrete values.",
        items: [
          "None",
          "19",
          "21",
          "22",
          "25",
          "26",
          "30",
          "35",
          "39",
          "41",
          "43",
          "44",
          "53",
          "57",
          "58",
          "59",
          "60",
          "76",
          "77",
          "78",
          "82",
          "85",
          "89",
          "90",
          "92",
          "99",
          "101",
          "106",
          "109",
          "110",
          "114",
          "117",
          "122",
          "124",
          "133",
          "138",
          "147",
          "149",
          "150",
          "163",
          "164",
          "165",
          "166",
          "169",
          "170",
          "173",
          "177",
          "179",
          "181",
          "182",
          "185",
          "188",
          "198",
          "201",
          "205",
          "213",
          "217",
          "218",
          "227",
          "230",
          "233",
          "238",
          "244",
          "245",
          "249",
          "265",
          "266",
          "267",
          "275",
          "281",
          "282",
          "293",
          "294",
          "298",
          "300",
          "301",
          "306",
          "308",
          "309",
          "310",
          "323",
          "326",
          "334",
          "339",
          "342",
          "346",
          "358",
          "373",
          "390",
          "394",
          "404",
          "407",
          "409",
          "410",
          "421",
          "428",
          "434",
          "436",
          "451",
          "458",
          "467",
          "473",
          "474",
          "476",
          "483",
          "492",
        ],
      },
    },
    [Page.DFSI_GROUP]: {
      "IWF-ID": {
        label: "IWF ID",
        tooltipText:
          "The ID of the IWF instance to which the DFSI Talk Group belongs",
      },
      FORMAT: {
        label: "Format",
        tooltipText:
          "Format for DFSI Logical Group ID. 'FF': FreeForm, 'PF': PreFixed",
        items: ["FreeForm", "PreFixed"],
      },
      "ENCRYPTION-ENABLED": {
        label: "Encryption Enabled",
        tooltipText:
          "Defines whether or not encryption is enabled on the DFSI Talk Group",
      },
      SLN: {
        label: "Storage Location Number",
        tooltipText:
          "Storage Location Number (SLN) is a pointer to a physical memory location, and logically represents each row in the key storage database (range 0-65535)",
      },
      "DFSI-LOGICAL-GID": {
        label: "DFSI Logical Group ID",
        tooltipText: "The ID of a logical group of DFSI channels.",
      },
      "CHANNEL-IDS": {
        label: "Channel IDs",
        tooltipText:
          "A collection of DFSI Channel IDs relating to the DFSI Talk Group",
      },
      "DFSI-GROUP-NAME": {
        label: "DFSI Group Name",
        tooltipText: "The name of the DFSI group.",
      },
    },
    [Page.IKI_CONNECTION]: {
      "CONNECTION-ID": {
        label: "Connection ID",
        tooltipText: "The ID of the IKI Connection.",
      },
      "IKI-NAME": {
        label: "IKI Name",
        tooltipText: "The name of the IKI Connection.",
      },
      "IKI-IPV4-ADDR": {
        label: "IKI IPV4 Address",
        tooltipText: "The IPv4 Address of the LMR-IWF gateway",
      },
      "IKI-PORT": {
        label: "IKI Port",
        tooltipText:
          "The port number of the LMR-IWF gateway (range 1024-65535)",
      },
      "IKI-RADIO-SET-IDENTIFIER": {
        label: "IKI Radio Set Identifier",
        tooltipText:
          "The Radio Set Identifier of the IKI entity (range 1-9999999)",
      },
      "IWF-RADIO-SET-IDENTIFIER": {
        label: "IWF Radio Set Identifier",
        tooltipText:
          "The Radio Set Identifier of the LMR-IWF (range 1-9999999)",
      },
      "UPLOAD-CERTIFICATE": {
        label: "Select a file or Drag and drop here",
        tooltipText: "Upload new IKI Certificate",
      },
    },
    [Page.ACTIVE_ALARM]: {},
    [Page.FAULTS]: {},
    [Page.INVENTORY]: {},
    [Page.INSTANCE]: {},
    [Page.HISTORICAL_ALARM]: {},
    [Page.PUBLISH_INFO]: {},
  },
  [GeneralTranslationCategory.EDIT_FORM_FIELDS]: {
    [Page.ORG]: {
      GROUP_PROFILE: {
        "UNIT-SECURITY": {
          label: "Unit Security",
          tooltipText:
            "The allowable security level (1=Clear, 2=Secure or 3=Both) of the unit-to-unit call.",
        },
        "UNIT-SLN": {
          label: "Unit Storage Location Number",
          tooltipText:
            "The Storage Location Number (SLN) that is used for unit-to-unit calls (range 0-4095).",
        },
      },
    },
    [Page.ORG_MAPPING]: {
      "IWF-ID": { label: "IWF ID", tooltipText: "The ID of the IWF." },
      "ORG-ID": {
        label: "Organisation ID",
        tooltipText: "The ID of the LMR Organisation.",
      },
    },
    [Page.ORG_TRANSLATION]: {
      FROM: {
        label: "Priority (Incoming)",
        tooltipText: "The Priority (Incoming) Value, range (0-65535).",
      },
      EFI: {
        label: "Emergency Flag (Incoming)",
        tooltipText: "The Emergency Flag (Incoming) Status",
      },
      EFO: {
        label: "Emergency Flag (Outgoing)",
        tooltipText: "The Emergency Flag (Outgoing) Status",
      },
      TO: {
        label: "Priority (Outgoing) Value",
        tooltipText: "The Priority (Outgoing) Value, range (0-65535).",
      },
    },
    [Page.LOCATION]: {},
    [Page.XSSI_CONNECTION]: {
      "RADIO-IPV4-ADDR": {
        label: "Radio IPV4 Address",
        tooltipText: "The IPv4 Address of the agency RNC gateway.",
      },
      "RADIO-RFSS-ID": {
        label: "Radio Frequency Subsystem ID",
        tooltipText: "The RFSS ID of the agency RNC gateway (range 1-65535)",
      },
      "RADIO-SYSTEM-ID": {
        label: "Radio System ID",
        tooltipText: "The System ID of the agency RNC gateway (range 1-4095)",
      },
      "RADIO-WACN-ID": {
        label: "Radio Wide Area Communications Network ID",
        tooltipText: "The WACN ID of the agency RNC gateway (range 1-1048575)",
      },
      "RADIO-RFSS-4-HEX-DIGIT": {
        label: "Radio RFSS 4 Hex Digit",
        tooltipText:
          "The agency supports a 4 hex digit format for the RFSS ID (default true)",
      },
      "IWF-RFSS-ID": {
        label: "IWF Radio Frequency SubSystem ID",
        tooltipText: "The RFSS ID of the LMR IWF gateway (range 1-65535)",
      },
      "IWF-SYSTEM-ID": {
        label: "IWF System ID",
        tooltipText: "The System ID of the LMR IWF gateway (range 1-4095)",
      },
      "IWF-WACN-ID": {
        label: "IWF Wide Area Communications Network ID",
        tooltipText: "The WACN ID of the LMR IWF gateway (range 1-1048575)",
      },
      "POLLING-ENABLED": {
        label: "Polling Enabled",
        tooltipText: "Enable polling of the agency RNC gateway (default true)",
      },
      "POLLING-INTERVAL-CONNECTED": {
        label: "Polling Interval Connected",
        tooltipText:
          "The polling time in seconds when connected to the agency RNC gateway (default 10, range 1-300)",
      },
      "POLLING-INTERVAL-DISCONNECTED": {
        label: "Polling Interval Disconnected",
        tooltipText:
          "The polling time in seconds when disconnected from the agency RNC gateway (default 10, range 1-300)",
      },
      "RESPONSES-BEFORE-CONNECTED": {
        label: "Responses Before Connected",
        tooltipText:
          "The number of responses before connected (default 1, range 1-100)",
      },
      "MISSED-RESPONSES-BEFORE-DISCONNECTED": {
        label: "Missed Responses Before Disconnected",
        tooltipText:
          "The number of missed responses before disconnected (default 3, range 1-100)",
      },
      "VOCODER-MODES": {
        label: "Vocoder Modes",
        tooltipText:
          "The vocoder modes supported by the agency (FR, HR, Native, Phase 1)",
      },
    },
    [Page.OTAR_CONNECTION]: {
      "KMF-IPV4-ADDR": {
        label: "KMF IPV4 Address",
        tooltipText: "The IPv4 address of the agency KMF",
      },
      "KMF-PORT": {
        label: "KMF Port",
        tooltipText: "The UDP port of the agency KMF (range 1024-65535)",
      },
      "KMF-RADIO-SET-IDENTIFIER": {
        label: "KMF Radio Set Identifier",
        tooltipText: "The radio set identifier of the KMF (range 1-9999999)",
      },
      "IWF-RADIO-SET-IDENTIFIER": {
        label: "IWF Radio Set Identifier",
        tooltipText: "The radio set identifier (range 1-9999999)",
      },
      "MESSAGE-NUMBER-PERIOD": {
        label: "Message Number Period",
        tooltipText:
          "The message number period for OTAR message validation(range 0-65535)",
      },
      "PRIVATE-CALL-SLN": {
        label: "Private Call Storage Location Number",
        tooltipText: "The SLN for private calls (range 0-4095)",
      },
      "GROUP-REGROUP-SLN": {
        label: "Group Regroup Storage Location Number",
        tooltipText: "The SLN for group regroup calls (range 0-4095)",
      },
      "OTAR-REGISTRATION-TIMER": {
        label: "OTAR Registration Timer",
        tooltipText:
          "Time in hours to send OTAR registration (default 8, range 1-72)",
      },
      "KEEP-ALIVE-TIMER": {
        label: "Keep Alive Timer",
        tooltipText:
          "Time in seconds to send OTNR connection keep alive message Hello(identification) (default 0, range 0-300)",
      },
      "OPT-SEND-REKEY-REQ": {
        label: "OPT Send Rekey Request",
        tooltipText: "Send a re-key request (default false)",
      },
      "OPT-DE-REGISTRATION": {
        label: "OPT De-registration",
        tooltipText: "Support De-Registration (default false)",
      },
      "OPT-REVERSE-WARM-START": {
        label: "OPT Reverse Warm Start",
        tooltipText:
          "Support Registration using Reverse Warm Start (default false)",
      },
      "OPT-HELLO-MAC-REPLY": {
        label: "OPT Hello MAC Reply",
        tooltipText: "Only reply to Hello that has a MAC (default false)",
      },
      "OPT-KEY-ASSIGNMENT": {
        label: "OPT Key Assignment",
        tooltipText: "Support OTAR key assignment (default false)",
      },
    },
    [Page.CANNED_MESSAGE]: {
      "CANNED-TEXT": {
        label: "Canned Text",
        tooltipText: "The LMR Canned Message Text.",
      },
    },
    [Page.LMR_USER]: {
      "LMR-NW-TYPE": {
        label: "LMR Network Type",
        tooltipText: "The type of network associated with the LMR User.",
      },
      "MAPPED-MCPTT-ID": {
        label: "MAPPED-MCPTT-ID",
        tooltipText: "The mapped MCPTT ID of the LMR User.",
      },
      "DISPLAY-NAME": {
        label: "Display Name",
        tooltipText: "The display name of the LMR User",
      },
      "MUTUAL-AID": {
        label: "Mutual Aid",
        tooltipText: "The mutual aid value of the LMR User",
      },
    },
    [Page.LMR_GROUP]: {
      "LMR-NW-TYPE": {
        label: "LMR Network Type",
        tooltipText: "The type of network associated with the LMR Talk Group.",
        items: ["P25-ISSI", "P25-DFSI"],
      },
      "MAPPED-MCPTT-GID": {
        label: "MAPPED-MCPTT-GID",
        tooltipText: "The mapped MCPTT Group ID of the LMR Talk Group.",
      },
      GROUP_PROFILE: {
        "GROUP-ACCESS-PERMISSION": {
          label: "Group Access Permission",
          tooltipText:
            "This property defines whether or not the group is allowed to make non-emergency calls at the Serving RFSS. Zero (0) indicates non-emergency calls on the group MAY NOT be placed from the Serving RFSS",
        },
        "GROUP-EMERGENCY-CAPABLE": {
          label: "Group Emergency Capable",
          tooltipText:
            "This property defines whether or not emergency calls may be made on the group. Zero (0) indicates that emergency calls are not allowed.",
        },
        "GROUP-CC-SETUP-TIME": {
          label: "Group CC Setup Time",
          tooltipText:
            "This property defines the maximum setup time for a confirmed call on the group. Zero (0) indicates that the call is unconfirmed. A value in the range (1-32766) specifies the setup time in tenths of seconds and indicates that the call is confirmed. A value of 32767 indicates an infinite setup time, and indicates that the call is confirmed.",
        },
        "GROUP-SECURITY": {
          label: "Group Security",
          tooltipText:
            "This property defines the allowable security level (1=Clear, 2=Secure or 3=Both) of the call.",
        },
        "GROUP-RFSS-ID": {
          label: "Group RFSS ID",
          tooltipText:
            "The RFSS-ID associated with the group when it is associated with an intra-system ISSI (range 0-65535)",
        },
        "GROUP-SLN": {
          label: "Group Storage Location Number",
          tooltipText:
            "Defines the Storage Location Number (SLN) that is mapped to the LMR group (range 0-4095).",
        },
      },
    },
    [Page.MCPTT_USER]: {
      "DISPLAY-NAME": {
        label: "Display Name",
        tooltipText: "The display name of the MC User.",
      },
      "MAPPED-P25-ID": {
        label: "MAPPED-P25-ID",
        tooltipText: "The mapped P25 ID of the MC User.",
      },
      "MAPPED-DMR-ID": {
        label: "MAPPED-DMR-ID",
        tooltipText: "The mapped DMR ID of the MC User.",
      },
      "MAPPED-ROIP-ID": {
        label: "MAPPED-ROIP-ID",
        tooltipText: "The mapped ROIP ID of the MC User.",
      },
      "MAPPED-DFSI-ID": {
        label: "MAPPED-DFSI-ID",
        tooltipText: "The mapped DFSI ID of the MC User.",
      },
      "SELECT A MAPPED-FIELD": {
        label: "Select a Mapped Field",
        tooltipText: "The mapped fields of the MC User.",
        items: [
          "MAPPED-P25-ID",
          "MAPPED-DFSI-ID",
          "MAPPED-ROIP-ID",
          "MAPPED-DMR-ID",
          "MAPPED-P25-ID + MAPPED-DFSI-ID",
        ],
      },
      "MUTUAL-AID": {
        label: "Mutual Aid",
        tooltipText: "The mutual aid value of the MC User",
      },
    },
    [Page.MCPTT_GROUP]: {
      "SELECT A MAPPED-FIELD": {
        label: "Select a Mapped Field",
        tooltipText: "The mapped values of the MC User.",
        items: [
          "MAPPED-P25-TG-ID",
          "MAPPED-DFSI-TG-ID",
          "MAPPED-ROIP-TG-ID",
          "MAPPED-DMR-TG-ID",
        ],
        placeholder: [
          "The mapped P25 Talk Group ID of the MC Group.",
          "The mapped DFSI Talk Group ID of the MC Group.",
          "The mapped ROIP Talk Group ID of the MC Group.",
          "The mapped DMR Talk Group ID of the MC Group.",
        ],
      },
      GROUP_PROFILE: {
        "GROUP-ACCESS-PERMISSION": {
          label: "Group Access Permission",
          tooltipText:
            "This property defines whether or not the group is allowed to make non-emergency calls at the Serving RFSS. Zero (0) indicates non-emergency calls on the group MAY NOT be placed from the Serving RFSS",
        },
        "GROUP-EMERGENCY-CAPABLE": {
          label: "Group Emergency Capable",
          tooltipText:
            "This property defines whether or not emergency calls may be made on the group. Zero (0) indicates that emergency calls are not allowed.",
        },
        "GROUP-CC-SETUP-TIME": {
          label: "Group CC Setup Time",
          tooltipText:
            "This property defines the maximum setup time for a confirmed call on the group. Zero (0) indicates that the call is unconfirmed. A value in the range (1-32766) specifies the setup time in tenths of seconds and indicates that the call is confirmed. A value of 32767 indicates an infinite setup time, and indicates that the call is confirmed.",
        },
        "GROUP-SECURITY": {
          label: "Group Security",
          tooltipText:
            "This property defines the allowable security level (1=Clear, 2=Secure or 3=Both) of the call.",
        },
        "GROUP-EXPIRATION-PERIOD": {
          label: "Group Expiration Period",
          tooltipText:
            "The SIP registration expiration interval set by the LMR-IWF acting as the group home RFSS range (14400, 4294967295)",
        },
        "GROUP-INTERRUPT-MODE": {
          label: "Group Interrupt Mode",
          tooltipText:
            "This property defines the audio interrupt mode of the talk group. Zero (0) indicates that audio interruption by SUs within a talk group call is never allowed, One (1) indicates that it is allowed based on SU priority, and Two (2) indicates that it is always allowed.",
        },
        "GROUP-RF-HANG-TIME": {
          label: "Group RF Hang Time",
          tooltipText:
            "This property defines the RF hang-timer for the group. The integer value is the RF hang-timer in tenths of seconds and is limited to the range (0-32676)",
        },
        "GROUP-EMERGENCY-PREEMPTION": {
          label: "Group Emergency Preemption",
          tooltipText:
            "This property defines the type of pre-emption to be applied for emergency calls, Zero (0) indicates non-ruthless, One (1) indicates ruthless.",
        },
        "GROUP-SLN": {
          label: "Group Storage Location Number",
          tooltipText:
            "Defines the Storage Location Number (SLN) that is mapped to the MCPTT group (range 0-4095).",
        },
        "GROUP-PRIORITY": {
          label: "Group Priority",
          tooltipText:
            "This property defines the suggested priority of the group when queuing group calls on a busy system, range (1-10)",
        },
      },
    },
    [Page.DFSI_CONNECTION]: {
      "IWF-ROLE": {
        label: "IWF Role",
        tooltipText: "The IWF DFSI role",
        items: ["Host", "Station"],
      },
      "HOST-CONTROL-IPV4-ADDR": {
        label: "Host Control IPV4 Address",
        tooltipText: "The IPv4 address of the host's control connection",
      },
      "HOST-CONTROL-PORT": {
        label: "Host Control Port",
        tooltipText:
          "The UDP port of the host's control connection (range 1024-65535)",
      },
      "HOST-VOICE-IPV4-ADDR": {
        label: "Host Voice IPV4 Address",
        tooltipText:
          "The IPv4 address of the host's voice conveyance connection",
      },
      "VOICE-PORT": {
        label: "Voice Port",
        tooltipText:
          "The UDP port of the host or fixed station's voice connection (range 1024-65535)",
      },
      "DATA-IPV4-ADDR": {
        label: "Data IPV4 Address",
        tooltipText:
          "DFSI v2 only, the IPv4 address of the host or fixed stations's data conveyance connection",
      },
      "DATA-PORT": {
        label: "Data Port",
        tooltipText:
          "DFSI v2 only, the UDP port of the host or fixed station's data connection (range 1024-65535)",
      },
      "FIXED-STATION-CONTROL-IPV4-ADDR": {
        label: "Fixed Station Control IPV4 Address",
        tooltipText:
          "The IPv4 address of the fixed station's control connection",
      },
      "FIXED-STATION-VOICE-IPV4-ADDR": {
        label: "Fixed Station Voice IPV4 Address",
        tooltipText:
          "The IPv4 address of the fixed station's voice conveyance connection (DFSI v1 only)",
      },
      "FIXED-STATION-CONTROL-PORT": {
        label: "Fixed Station Control Port",
        tooltipText:
          "The UDP port of the fixed station's control connection (range 1024-65535)",
      },
      "CONNECTIVITY-TX-TIMER": {
        label: "Connectivity Tx Timer",
        tooltipText:
          "The fixed station and host heartbeat send period in seconds (range 1-255)",
      },
      "CONNECTIVITY-LOSS-LIMIT": {
        label: "Connectivity Loss Limit",
        tooltipText:
          "The number of missed heartbeats before disconnected (range 1-100)",
      },
      "FS-HEARTBEAT-PERIOD": {
        label: "Fixed Station Heartbeat Period",
        tooltipText:
          "DFSI v1 only, the fixed station heartbeat period (range 1-255)",
      },
      "HOST-HEARTBEAT-PERIOD": {
        label: "Host Heartbeat Period",
        tooltipText: "DFSI v1 only, the host heartbeat period (range 1-255)",
      },
      "CONTROL-RETRY-TIME": {
        label: "Control Retry Time",
        tooltipText:
          "The control connection retry period in milliseconds (range 1-5000)",
      },
      "CONTROL-ATTEMPT-LIMIT": {
        label: "Control Attempt Limit",
        tooltipText: "The control connection retry attempt limit (range 1-10)",
      },
      "OUTBOUND-MAX-CAI-DATA-BLOCKS": {
        label: "Outbound Max Common Air Interface Data Blocks",
        tooltipText:
          "DFSI v2 only, the maximum number of outbound data blocks on the common air interface (range 1-128)",
      },
      "INBOUND-MAX-CAI-DATA-BLOCKS": {
        label: "Inbound Max Common Air Interface Data Blocks",
        tooltipText:
          "DFSI v2 only,the maximum number of inbound data blocks on the common air interface (range 1-128)",
      },
      "ACKNOWLEDGEMENT-DELAY": {
        label: "Acknowledgement Delay",
        tooltipText:
          "The number of seconds to delay acknowledgement (range 0-2)",
      },
      "INBOUND-REPEAT": {
        label: "Inbound Repeat",
        tooltipText: "Repeat inbound DFSI traffic",
      },
      "FIXED-STATION-VOTER-REPORTING-PERIOD": {
        label: "Fixed Station Voter Reporting Period",
        tooltipText: "The fixed station voter reporting period (range 1-255)",
      },
      "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL": {
        label: "Fixed Station Transmitter Report Interval",
        tooltipText:
          "DFSI v2 only, the fixed station transmitter report interval (range 1-255)",
      },
    },
    [Page.DFSI_CHANNEL]: {
      "OUTBOUND-NETWORK-ACCESS-CODE": {
        label: "Outbound Network Access Code",
        tooltipText:
          "A 12-bit network access code associated with a group's outbound voice transmissions (range 0-4095). Typically 0x293 (659) is configured by default, 0xF7E (3966) and 0xF7F (3967) are not allowed",
      },
      "INBOUND-NETWORK-ACCESS-CODE": {
        label: "Inbound Network Access Code",
        tooltipText:
          "A 12-bit network access code associated with a group's inbound voice transmissions (range 0-4095). Typically 0x293 (659) is configured by default, 0xF7E (3966) and 0xF7F (3967) are not allowed.",
      },
      "OTA-GROUP-ID": {
        label: "OTA Group ID",
        tooltipText:
          "A 16-bit over-the-air Talk Group ID associated with the conventional group (range 1-65535).",
      },
      "CARRIER-SQUELCH": {
        label: "Carrier Squelch",
        tooltipText: "",
      },
      "CHANNEL-MODE": {
        label: "Channel Mode",
        tooltipText:
          "The DFSI channel operating in either analog or digital mode.",
      },
      "CTC-SQUELCH-SYSTEM": {
        label: "CTC Squelch System",
        tooltipText:
          "Continuous Tone Coded Squelch System, Table 15 TIA.102 BAHA-A. Analog audio tone added to PTT, these are discrete values.",
        items: [
          "None",
          "0",
          "670",
          "693",
          "719",
          "744",
          "770",
          "797",
          "825",
          "854",
          "885",
          "915",
          "948",
          "974",
          "1000",
          "1035",
          "1072",
          "1109",
          "1148",
          "1188",
          "1230",
          "1273",
          "1318",
          "1365",
          "1413",
          "1462",
          "1514",
          "1567",
          "1622",
          "1679",
          "1738",
          "1799",
          "1862",
          "1928",
          "2035",
          "2065",
          "2107",
          "2181",
          "2257",
          "2291",
          "2336",
          "2418",
          "2503",
          "2541",
        ],
      },
      "CDC-SQUELCH-SYSTEM": {
        label: "CDC Squelch System",
        tooltipText:
          "Continuous Digital Coded Squelch System, Table 15 TIA.102 BAHA-A. Digital tone added to PTT, these are discrete values.",
        items: [
          "None",
          "19",
          "21",
          "22",
          "25",
          "26",
          "30",
          "35",
          "39",
          "41",
          "43",
          "44",
          "53",
          "57",
          "58",
          "59",
          "60",
          "76",
          "77",
          "78",
          "82",
          "85",
          "89",
          "90",
          "92",
          "99",
          "101",
          "106",
          "109",
          "110",
          "114",
          "117",
          "122",
          "124",
          "133",
          "138",
          "147",
          "149",
          "150",
          "163",
          "164",
          "165",
          "166",
          "169",
          "170",
          "173",
          "177",
          "179",
          "181",
          "182",
          "185",
          "188",
          "198",
          "201",
          "205",
          "213",
          "217",
          "218",
          "227",
          "230",
          "233",
          "238",
          "244",
          "245",
          "249",
          "265",
          "266",
          "267",
          "275",
          "281",
          "282",
          "293",
          "294",
          "298",
          "300",
          "301",
          "306",
          "308",
          "309",
          "310",
          "323",
          "326",
          "334",
          "339",
          "342",
          "346",
          "358",
          "373",
          "390",
          "394",
          "404",
          "407",
          "409",
          "410",
          "421",
          "428",
          "434",
          "436",
          "451",
          "458",
          "467",
          "473",
          "474",
          "476",
          "483",
          "492",
        ],
      },
    },
    [Page.DFSI_GROUP]: {
      "CHANNEL-IDS": {
        label: "Channel IDs",
        tooltipText:
          "A collection of DFSI Channel IDs relating to the DFSI Talk Group",
      },
      "ENCRYPTION-ENABLED": {
        label: "Encryption Enabled",
        tooltipText:
          "Defines whether or not encryption is enabled on the DFSI Talk Group",
      },
      SLN: {
        label: "Storage Location Number",
        tooltipText:
          "Storage Location Number (SLN) is a pointer to a physical memory location, and logically represents each row in the key storage database (range 0-65535)",
      },
    },
    [Page.IKI_CONNECTION]: {
      "IKI-NAME": {
        label: "IKI Name",
        tooltipText: "The name of the IKI Connection.",
      },
      "IKI-IPV4-ADDR": {
        label: "IKI IPV4 Address",
        tooltipText: "The IPv4 Address of the LMR-IWF gateway",
      },
      "IKI-PORT": {
        label: "IKI Port",
        tooltipText:
          "The port number of the LMR-IWF gateway (range 1024-65535)",
      },
      "IKI-RADIO-SET-IDENTIFIER": {
        label: "IKI Radio Set Identifier",
        tooltipText:
          "The Radio Set Identifier of the IKI entity (range 1-9999999)",
      },
      "IWF-RADIO-SET-IDENTIFIER": {
        label: "IWF Radio Set Identifier",
        tooltipText:
          "The Radio Set Identifier of the LMR-IWF (range 1-9999999)",
      },
      "UPLOAD-CERTIFICATE": {
        label: "Select a file or Drag and drop here",
        tooltipText: "Upload new IKI Certificate",
      },
    },
    [Page.ACTIVE_ALARM]: {},
    [Page.FAULTS]: {},
    [Page.INVENTORY]: {},
    [Page.INSTANCE]: {},
    [Page.HISTORICAL_ALARM]: {},
    [Page.PUBLISH_INFO]: {
      "GROUP-ID": {
        label: "Group ID",
        tooltipText: "The ID of the Group to which the user has affiliated",
      },
      "USER-ID": { label: "User ID", tooltipText: "The ID of the User." },
      "SECS-TO-EXPIRE": {
        label: "Seconds to Expire",
        tooltipText:
          "The number of seconds remaining before affiliation has expired.",
      },
    },
  },
  [GeneralTranslationCategory.VIEW_FORM_FIELDS]: {
    [Page.ORG]: {},
    [Page.ORG_MAPPING]: {},
    [Page.ORG_TRANSLATION]: {},
    [Page.LOCATION]: {},
    [Page.XSSI_CONNECTION]: {},
    [Page.OTAR_CONNECTION]: {},
    [Page.CANNED_MESSAGE]: {},
    [Page.LMR_USER]: {},
    [Page.LMR_GROUP]: {},
    [Page.MCPTT_USER]: {},
    [Page.MCPTT_GROUP]: {},
    [Page.DFSI_CONNECTION]: {},
    [Page.DFSI_CHANNEL]: {},
    [Page.DFSI_GROUP]: {},
    [Page.P25_UNIT]: {
      Ref: "Reference ID",
      "TARGET-ID": {
        label: "Target ID",
        tooltipText: "Query based on a TARGET-ID",
      },
      PERIOD: "Period",
      RFSS: { label: "RFSS", tooltipText: "Query based on an RFSS ID" },
      MONITOR: "Monitor",
      CreationDate: "Creation Date",
      ModificationDate: "Modification Date",
    },
    [Page.FIXED_NETWORK_ELEMENT]: {
      Ref: "Reference ID",
      "TARGET-ID": {
        label: "Target ID",
        tooltipText: "Query based on a TARGET-ID",
      },
      PERIOD: "Period",
      RFSS: { label: "RFSS", tooltipText: "Query based on an RFSS ID" },
      MONITOR: "Monitor",
      CreationDate: "Creation Date",
      ModificationDate: "Modification Date",
    },
    [Page.ACTIVE_ALARM]: {
      "EVENT-ID": "Event ID",
      VERSION: "Version",
      INSTANCE: "Instance",
      CreatedAt: "Created At",
      HOSTNAME: "Hostname",
      "NOTIFICATION-ID": "Notification ID",
      "APP-REF": "App Reference",
      "SUB-COMPONENT": "Sub-Component",
    },
    [Page.FAULTS]: {
      "ROW-ID": "Row ID",
      "EVENT-ID": "Event ID",
      VERSION: "Version",
      INSTANCE: "Instance",
      CreatedAt: "Created At",
      HOSTNAME: "Hostname",
      "ADDITIONAL-INFO": "Additional Info",
    },
    [Page.INVENTORY]: {
      "EVENT-ID": "Event ID",
      "EVENT-NAME": "Event Name",
      "EVENT-PERCEIVED-SEVERITY": "Event Perceived Severity",
      "EVENT-SYMPTOMS": "Event Symptoms",
      "SOURCE-COMPONENT": "Source Component",
      "INHIBITED-AT": "Inhibited At",
      "ALARM-TYPE": "Alarm Type",
      CreatedAt: "Created At",
      "EVENT-DESCRIPTION": "Event Description",
      "EVENT-PROBABLE-CAUSE": "Event Probable Cause",
      "EVENT-RESOLUTION": "Event Resolution",
      "EVENT-SPECIFIC-PROBLEM": "Event Specific Problem",
      "EVENT-TYPE": "Event Type",
      "SOURCE-APPLICATION": "Source Application",
    },
    [Page.INSTANCE]: {
      ID: "ID",
      "ENGINE-ID": "Engine ID",
      HOSTNAME: "Hostname",
      INSTANCE: "Instance",
      "STARTED-AT": "Started At",
    },
    [Page.HISTORICAL_ALARM]: {
      "ROW-ID": "Row ID",
      "EVENT-ID": "Event ID",
      "NOTIFICATION-ID": "Notification ID",
      "ROW-TYPE": "Row Type",
      VERSION: "Version",
      INSTANCE: "Instance",
      CreatedAt: "Created At",
      HOSTNAME: "Hostname",
      "APP-REF": "App Reference",
      "SUB-COMPONENT": "Sub-Component",
    },
    [Page.PUBLISH_INFO]: {},
    [Page.P25_GROUP]: {
      Ref: "Reference ID",
      "TARGET-ID": {
        label: "Target ID",
        tooltipText: "Query based on a TARGET-ID",
      },
      MONITOR: "Monitor",
      PERIOD: "Period",
      RFSS: { label: "RFSS", tooltipText: "Query based on an RFSS ID" },
      CreationDate: "Creation Date",
      ModificationDate: "Modification Date",
    },
    [Page.P25_AFFILIATIONS]: {
      Ref: "Reference ID",
      "TARGET-ID": {
        label: "Target ID",
        tooltipText: "Query based on a TARGET-ID",
      },
      PERIOD: "Period",
      RFSS: {
        label: "RFSS",
        tooltipText: "Query based on an RFSS ID",
      },
      MONITOR: "Monitor",
      CreationDate: "Creation Date",
      ModificationDate: "Modification Date",
    },
  },
  [GeneralTranslationCategory.BREADCRUMBS]: {
    configurationmanagement: "Configuration Management",
    cannedmessages: "Canned Messages",
    lmrgroups: "LMR Groups",
    lmrusers: "LMR Users",
    mcpttgroups: "MCPTT Groups",
    dfsiconnections: "DFSI Connections",
    dfsichannels: "DFSI Channels",
    dfsigroups: "DFSI Groups",
    mcpttusers: "MCPTT Users",
    locations: "Locations",
    organizationmapping: "Organisation Mappings",
    organizations: "Organisations",
    organizationtranslation: "Organisation Translations",
    otarconnections: "OTAR Connections",
    xssiconnections: "XSSI Connections",
    ikiconnections: "IKI Connections",
    new: "New",
    bulk: "Bulk Upload",
    faultmanagement: "Fault Management",
    activealarms: "Active Alarms",
    faults: "Faults",
    inventory: "Inventory",
    instances: "Instances",
    historicalalarms: "Historical Alarms",
    realtime: "Realtime",
    publishinfo: "Publish Info",
    p25unit: "P25 Supp. Service Reg. (Unit)",
    p25group: "P25 Supp. Service Reg. (Group)",
    fixednetworkelement: "P25 Supp. Service Reg. (FNE)",
    p25groupaffiliations: "P25 Group Affiliations",
    overview: "Overview",
    default: "Home",
  },
  [GeneralTranslationCategory.TOGGLE]: {
    labelA: "Off",
    labelB: "On",
    "un-suppress": "un-suppress",
    suppress: "suppress",
  },
  [GeneralTranslationCategory.HEX_INPUT]: {
    HEX: "HEX",
    DEC: "DEC",
    dropdownLabel: "Select HEX/DEC",
  },
  [GeneralTranslationCategory.MISC]: {
    ORG_DROPDOWN: {
      label: "Select Organisation",
      placeholder: "Select an Organisation...",
    },
  },
  [GeneralTranslationCategory.FILTER_COLUMNS]: {
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "RADIO-IPV4-ADDR": "Radio IPV4 Address",
      "RADIO-RFSS-ID": "Radio Frequency Subsystem ID",
      "RADIO-SYSTEM-ID": "Radio System ID",
      "RADIO-WACN-ID": "Radio Wide Area Communications Network ID",
    },
    [Page.P25_GROUP]: {
      RFSS: "RFSS",
      "TARGET-ID": "Target ID",
    },
    [Page.FIXED_NETWORK_ELEMENT]: {
      RFSS: "RFSS",
      "TARGET-ID": "Target ID",
    },
    [Page.LMR_GROUP]: {
      "TG-ID": "Talk Group ID",
      "MAPPED-MCPTT-GID": "MAPPED MCPTT GID",
      "LMR-NW-TYPE": "LMR Network Type",
    },
    [Page.DFSI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
    },
    [Page.LMR_USER]: {
      "LMR-ID": "Land Mobile Radio ID",
      "LMR-NW-TYPE": "LMR Network Type",
      "MAPPED-MCPTT-ID": "Mapped MCPTT ID",
      "DISPLAY-NAME": "Display Name",
      "MUTUAL-AID": "Mutual Aid",
    },
    [Page.MCPTT_GROUP]: {
      "MCPTT-GID": "MCPTT GID",
      "MAPPED-P25-TG-ID": "Mapped P25 TG ID",
      "MAPPED-DMR-TG-ID": "Mapped DMR TG ID",
      "MAPPED-ROIP-TG-ID": "Mapped ROIP TG ID",
      "MAPPED-DFSI-TG-ID": "Mapped DFSI TG ID",
    },
    [Page.MCPTT_USER]: {
      "MCPTT-ID": "MCPTT ID",
      "MAPPED-P25-ID": "Mapped P25 ID",
      "MAPPED-DMR-ID": "Mapped DMR ID",
      "MAPPED-ROIP-ID": "Mapped ROIP ID",
      "MAPPED-DFSI-ID": "Mapped DFSI ID",
      "DISPLAY-NAME": "Display Name",
      "MUTUAL-AID": "Mutual Aid",
    },
    [Page.OTAR_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "KMF-RADIO-SET-IDENTIFIER": "KMF Radio Set Identifier",
    },
    [Page.CANNED_MESSAGE]: {
      "MSG-ID": "Message ID",
      "CANNED-TEXT": "Canned Text",
    },
    [Page.ORG]: {
      "Organisation ID": "Organisation ID",
      "Organisation Name": "Organisation Name",
    },
    [Page.ORG_TRANSLATION]: {
      ID: "ID",
      EFI: "Emergency Flag (Incoming)",
      EFO: "Emergency Flag (Outgoing)",
      FROM: "Priority (Incoming)",
      TO: "Priority (Outgoing) Value",
    },
    [Page.ORG_MAPPING]: {
      "IWF-ID": "IWF ID",
      "ORG-ID": "ORG-ID",
    },
    [Page.LOCATION]: {
      "IWF ID": "IWF ID",
      "IWF Location Name": "IWF Location Name",
      "IWF Domain Name": "IWF Domain Name",
    },
    [Page.IKI_CONNECTION]: {
      "CONNECTION-ID": "Connection ID",
      "IKI-IPV4-ADDR": "IKI IPv4 Address",
      "IKI-PORT": "IKI Port",
      "IKI-NAME": "IKI Name",
    },
    [Page.PUBLISH_INFO]: {
      "GROUP-ID": "Group ID",
      "USER-ID": "User ID",
    },
    [Page.P25_UNIT]: {
      RFSS: "RFSS",
      "TARGET-ID": "Target ID",
    },
    [Page.P25_AFFILIATIONS]: {
      RFSS: "RFSS",
      "TARGET-ID": "Target ID",
    },
  },
  [GeneralTranslationCategory.TAB_LIST]: {
    ConfigurationManagement: "Configuration Management",
    RealTimeManagement: "Realtime Management",
  },
  [GeneralTranslationCategory.TILE_LIST]: {
    ConfigurationManagement: {
      LMRUsers: "LMR Users",
      LMRGroups: "LMR Groups",
      LMRMessages: "LMR Messages",
      MCGroups: "MC Groups",
      MCUsers: "MC Users",
      DFSIGroups: "DFSI Groups",
      DFSIChannels: "DFSI Channels",
      DFSIConnections: "DFSI Connections",
      XSSIConnections: "XSSI Connections",
      OTARConnections: "OTAR Connections",
    },
    RealTimeManagement: {
      PublishInfo: "Publish Info",
      P25Unit: "P25 Supp. Service Reg. (Unit)",
      P25Group: "P25 Supp. Service Reg. (Group)",
      FixedNetwork: "P25 Supp. Service Reg. (FNE)",
      Affiliation: "P25 Group Affiliations",
    },
    OrgTileList: {
      Organisations: "Organisations",
      Mappings: "Mappings",
      Locations: "Locations",
    },
  },

  [GeneralTranslationCategory.OVERVIEW_TILE]: {
    labels: {
      total: "Total",
      min: "Min",
      max: "Max",
      avg: "Avg",
    },
    btnLabel: "Top10",
  },
  [GeneralTranslationCategory.AUTH]: {
    header: "Sign In",
    description: "Sign in with your corporate credentials",
    authFields: {
      label: {
        username: "Username",
        password: "Password",
      },
      placeholder: {
        username: "Username",
        password: "Password",
      },
    },
    btnLabels: {
      submit: "Sign In",
      logOut: "Logout",
    },
  },
  [GeneralTranslationCategory.DATA_TABLE_GENERAL]: {
    noDataForSelectedOrg: {
      infoAlert: {
        heading: "No Data found for this organisation!",
        subText:
          "No rows match the current filters, please Remove/Update some filters to view the results",
      },
    },
  },
  [GeneralTranslationCategory.MENU_TEXT]: {
    OverviewMenuItems: {
      parentItem: "Overview",
      childrenItems: {},
    },
    ConfigurationManagementMenuItems: {
      parentItem: "Configuration Management",
      childrenItems: {
        Organisations: "Organisations",
        OrgTranslations: "Organisation Translations",
        OrgMappings: "Organisation Mappings",
        Locations: "Locations",
        LMRUsers: "LMR Users",
        LMRGroups: "LMR Groups",
        CannedMsgs: "Canned Messages",
        MCGroups: "MCPTT Groups",
        MCUsers: "MCPTT Users",
        DFSIGroups: "DFSI Groups",
        DFSIChannels: "DFSI Channels",
        DFSIConnections: "DFSI Connections",
        XSSIConnections: "XSSI Connections",
        OTARConnections: "OTAR Connections",
        IKIConnections: "IKI Connections",
      },
    },
    FaultManagementMenuItems: {
      parentItem: "Fault Management",
      childrenItems: {
        ActiveAlarms: "Active Alarms",
        Faults: "Faults",
        Inventory: "Inventory",
        Instances: "Instances",
        HistoricalAlarms: "Historical Alarms",
      },
    },
    RealTimeManagementMenuItems: {
      parentItem: "Realtime",
      childrenItems: {
        PublishInfo: "Publish Info",
        P25Unit: "P25 Supp. Service Reg. (Unit)",
        P25Group: "P25 Supp. Service Reg. (Group)",
        FixedNetwork: "P25 Supp. Service Reg. (FNE)",
        Affiliation: "P25 Group Affiliations",
      },
    },
  },
  [GeneralTranslationCategory.BULK_UPLOAD]: {
    TabList: {
      tabName: {
        import: "Import",
        upload: "Upload",
        report: "Report",
      },
    },
    handleBulkUploadPageHeaderText: (moduleName: string) =>
      `Create Bulk ${moduleName}`,
    DragnDropLabelText: "Drag & Drop or Click here to import file",
    InvalidFileTypeText: "Invalid File Type. Please upload csv file.",
    InvalidCertificateTypeText:
      "Invalid Certificate. Please upload a .crt or .pem file.",
    ColumnMismatchText:
      "Column Mismatch. Please ensure that the columns in the uploaded file match the template exactly.",
    MaxRowLimitText:
      "Maximum Rows Limit Reached. Only 1000 records allowed in one entry",
    BulkUploadModal: {
      header: "Caution",
      descriptionText:
        "Do not refresh, close, or interupt the process while the upload is in progress.",
      handleProgressHelperText: (
        count: number,
        maxRowCount: number,
        moduleName: string
      ) => `${count}/${maxRowCount} ${moduleName}s created`,
      waitingHelperText: "Please Wait...",
      doneHelperText: "Done",
    },
    Notes: {
      title: "Instructions",
      point1: "Maximum 1000 records allowed in one entry",
      point2: "Only one file at a time is allowed",
      dfsiChannelNote1: `If Channel-Mode is Digital then default value for Outbound-Network-Access-Code and Inbound-Network-Access-Code fields is 0x293(659)`,
      hexValueNote: `All hexadecimal values MUST be prefixed with "0x" to explicitly denote hexadecimal representation`,
    },
    ImportTab: {
      title: "Select a file to import",
      downloadTemplateInstructionText:
        "Click here to download a sample file for bulk upload.",
      downloadTemplateLinkText: "Download Template CSV File",
      handleFileUpoadtext: (filename: string) =>
        `File ${filename} has been selected`,
      uploadButtonLabel: "Upload File",
    },
    ErrorTab: {
      title: "Upload Summary",
      readOnlyData: {
        fileLabel: "File Name ",
        timestampLabel: "Upload Date & Time ",
        totalRowsLabel: "Total Rows ",
        handleTotalConnectionsCreatedLabel: (moduleName: string) =>
          `${moduleName}s Created `,
        errorLabel: "Errors Generated While Uploading",
        downloadErrorReportInstructionText:
          "Download the error report to review and correct",
        downloadErrorLinkText: "Download Error Report",
        errorMessage: "No records created",
      },
    },
    InfoAlert: {
      header: "No Report to Show",
      subHeader: "Please upload file to view status reports.",
    },
    RowInfoAlert: {
      header: "Maximum Rows Limit Reached",
      subHeader:
        "Uploaded file exceeds the maximum allowed limit of 1000 rows.",
    },
    ColumnInfoAlert: {
      header: "Column Mismatch Detected",
      subHeader:
        "Please check your file again. Please ensure that columns in your file matches exactly with the columns provided in template.",
    },
    ProgressBar: {
      finshedLabelText: "Bulk Upload Finished",
      dataProcessingLabelText: "Data Processing",
    },
  },
};
